import { __decorate } from "tslib";
import { Component, Prop, Vue } from "vue-property-decorator";
let Backbutton = class Backbutton extends Vue {
    constructor() {
        super(...arguments);
        this.phones = this.$store.state.deliveryMenu.phones;
    }
    getUrl() {
        if (this.contactUs) {
            const url = `https://wa.me/529981868389/`;
            return url + "?text=Asunto: " + this.issue + " Mas Detalles: " + this.moreDetails;
        }
        else {
            const url = `https://wa.me/52${this.phones.whatsapp.phone}/`;
            if (this.phones.whatsapp.message != "") {
                return url + "?text=" + encodeURI(this.phones.whatsapp.message);
            }
        }
    }
    click() {
        this.$emit('click');
        if (/^[0-9]*$/.test(this.phones.whatsapp.phone)) {
            window.open(this.getUrl(), '_blank');
        }
    }
};
__decorate([
    Prop({ default: false })
], Backbutton.prototype, "contactUs", void 0);
__decorate([
    Prop({ default: "" })
], Backbutton.prototype, "issue", void 0);
__decorate([
    Prop({ default: "" })
], Backbutton.prototype, "moreDetails", void 0);
Backbutton = __decorate([
    Component
], Backbutton);
export default Backbutton;
